import { CommonStrings } from "../../../../../common/classes/CommonStrings";
import { IBBetriebRouteDefs } from "../../../routing/IBBetriebRouteDefs";

export class GeschaeftsfuehrungRouteDefs {
  public static FEATURE_PATH = "geschaeftsfuehrung";
  public static PARAM_ID = "Id";

  public static FQ_PATH = `${IBBetriebRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}`;
  public static LIST_PATH = `${CommonStrings.KW_LIST}`;
  public static LIST_FQ_PATH = `${IBBetriebRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.LIST_PATH}`;
  public static CREATE_PATH = `${CommonStrings.KW_CREATE}`;
  public static CREATE_FQ_PATH = `${IBBetriebRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.CREATE_PATH}`;
  public static UPDATE_PATH = `:${this.PARAM_ID}`;
  public static UPDATE_FQ_PATH = `${IBBetriebRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.UPDATE_PATH}`;

  public static getFQR = () => this.FQ_PATH;

  public static getFQRList = () => this.LIST_FQ_PATH;

  public static getFQRCreate = () => this.CREATE_FQ_PATH;

  public static getFQRUpdate = (id: string) => this.UPDATE_FQ_PATH.replaceAll(this.UPDATE_PATH, id);
}
